export default __webpack_public_path__ + "static/media/prox_cursos_presenciales.8e915cb3.jpg";